import { CollectiblesTabIcon } from "../../../shared/icons/CollectiblesTabIcon";
import { LearningTabIcon } from "../../../shared/icons/LearningTabIcon";
import { CollectiblesTab } from "../collectibles-tab";
import { LearningTab } from "../learning-tab";

export const tabsContent = [
  {
    title: "Learning",
    slug: "/participant/learning",
    icon: <LearningTabIcon />,
    component: (props?) => <LearningTab {...props} />,
    id: "learning-wt",
  },
  {
    title: "Collectibles",
    slug: "/participant/collectibles",
    icon: <CollectiblesTabIcon />,
    component: (props?) => <CollectiblesTab {...props} />,
    id: "collectibles-wt",
  },
];
